import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {useState} from 'react';
import {
  Button,
  Modal,
  Form,
  Row,
  Col,
} from 'react-bootstrap';
import TimePickerComponent from 'components/DateTime/TimePicker';
import DatePickerComponent from 'components/DateTime/DatePicker';
import DNS from 'components/DNS/dns.js';
import NotificationAlert from 'react-notification-alert';
import CircularProgress from '@mui/material/CircularProgress';
import {useTranslation} from 'react-i18next';
import {translations} from '../../i18n/translations';
import {FaTimes} from 'react-icons/fa';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';


const ModalEDITTableList = ({showModalValue, setShowModal, showTodayDate, showVisitorEmailRequired, showVisitorEntreprise, setVisitorEntreprise, showMaxdayDate, getAppointment, showApPk, showVFirstName, setVFirstName, showVLastName, setVLastName, showHour, setHour, showDate, setDate, showComments, setComments, showVisitorEmail, setVisitorEmail, showLanguageMail, setLanguageMail}) => {
  const token = useSelector((state) => state.token);
  const currentBuilding = useSelector((state) => state.currentBuilding);
  const [validated, setValidated] = useState(false);
  const [loading, setLoading] = useState(false);
  const [noEmailChecked, setNoEmailChecked] = useState(false);
  const {t} = useTranslation();
  const [sendEmail, setSentEmail] = useState(false);
  const animatedComponents = makeAnimated();

  useEffect(() => {
    console.log(showVisitorEmail == 'email@email.com');
    if (showVisitorEmail == 'email@email.com') {
      setNoEmailChecked(true);
    }
  }, [showModalValue == true]);

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false || showVFirstName == '' || showVLastName == '' || showHour == '' || showDate == '' || (showVisitorEmailRequired == true && showVisitorEmail == '')) {
      event.preventDefault();
      event.stopPropagation();
    }
    setValidated(true);
  };


  const resetValues = () => {
    setLoading(false);
    setValidated(false);
    setShowModal(false);
    setNoEmailChecked(false);
    setLanguageMail('');
    setHour('');
    setDate('');
    setComments('');
    setVFirstName('');
    setVLastName('');
    setVisitorEmail('');
    setVisitorEntreprise('');
    setSentEmail(false);
  };

  const notificationAlertRef = React.useRef(null);
  const notify = (place) => {
    const type = 'success';
    let options = {};
    options = {
      place: place,
      message: (
        <div>
          <div>
            <p>{t(translations.APPOINTMENT_EDIT_CONFIRM)}</p>
          </div>
        </div>
      ),
      type: type,
      icon: 'nc-icon nc-check-2',
      autoDismiss: 7,
    };
    notificationAlertRef.current.notificationAlert(options);
  };

  const notify2 = (place, txt, typeNot, iconNot) => {
    const type = typeNot;
    let options = {};
    options = {
      place: place,
      message: (
        <div>
          <div>
            <p>{txt}</p>
          </div>
        </div>
      ),
      type: type,
      icon: iconNot,
      autoDismiss: 7,
    };
    notificationAlertRef.current.notificationAlert(options);
  };

  const checkTime = () => {
    if (typeof(showHour) == typeof('string')) {
      return (new Date('June 04, 2022 ' + showHour));
    } else {
      return (showHour);
    }
  };

  const capitalizeFirstLetter = (str) => {
    if (!str) return ''; // Handle empty or null strings
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  const editAppointment = (event) => {
    event.preventDefault();
    const formatFirstName = showVFirstName[0].toUpperCase() + showVFirstName.slice(1);
    const fullname = showVLastName.toUpperCase() + ' ' + formatFirstName;
    const ddate = new Date(showDate);
    const day = ddate.getDate();
    const monthIndex = ddate.getMonth();
    const year = ddate.getFullYear();
    const myFormattedDate = year + '-' + ((monthIndex + 1) >= 10 ? (monthIndex + 1) : '0'+ (monthIndex + 1)) + '-' + day;
    const requestOptions = {
      method: 'PATCH',
      headers: {'Content-Type': 'application/json', 'Authorization': 'token ' + token['tokenRedux']},
      body: JSON.stringify({
        'pk': showApPk,
        'time': typeof(showHour) == typeof(new Date()) ? showHour.getHours() + ':' + showHour.getMinutes() : showHour,
        'date': myFormattedDate,
        'visitor': fullname,
        'first_name_visitor': capitalizeFirstLetter(showVFirstName),
        'last_name_visitor': showVLastName.toUpperCase(),
        'commentaire': showComments,
        'visitor_email': showVisitorEmail == '' ? 'email@email.com' : showVisitorEmail,
        'visitor_entreprise': showVisitorEntreprise,
        'force_send_email': sendEmail,
        'language_mail': showLanguageMail.value,
      }),
    };
    setLoading(true);
    fetch(DNS + '/list/deleteGetPatchAppointment/' + currentBuilding['currentbuildingRedux'].pk + '/', requestOptions)
        .then(async (response) => {
          const data = await response.json();
          setLoading(false);
          // debugger;
          if (data.status == 'OK') {
            notify('tc');
            resetValues();
            getAppointment();
          } else {
            console.log('FAILED REQUEST');
            return;
          }
        });
  };

  const handleIconClick = () => {
    setVisitorEmail('email@email.com');
    if (showVisitorEmailRequired) {
      notify2('tc', t(translations.APPOINTMENT_INFO_DNA), 'warning', 'nc-icon nc-check-2');
    }
  };

  return (
    <>
      <NotificationAlert ref={notificationAlertRef}/>
      <Modal
        className="modal modal-primary"
        onSubmit={() => editAppointment(event)}
        show={showModalValue}
        onHide={() => {
          if (!loading) {
            setShowModal(false);
          }
        }}
        autoFocus={false}
        enforceFocus={false}
      >
        <Modal.Header className="justify-content-center">
          <div className="modal-profile">
            <i className="nc-icon fa fa-edit"></i>
          </div>
          <Button variant="link" className="close-btn" onClick={() => setShowModal(false)}>
            <FaTimes style={{color: 'red', fontSize: '1.5rem'}} />
          </Button>
        </Modal.Header>
        {!loading ?
          <div className="modal-body">
            <p className="text-center">{t(translations.APPOINTMENT_MODAL_TITLE2)} </p>
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
              <Form.Group as={Row} controlId="formHorizontalVisiteurL">
                <Form.Label column sm={4}>
                  {t(translations.APPOINTMENT_MODAL_LAST_NAME) + ':'}
                </Form.Label>
                <Col sm={8}>
                  <Form.Control
                    type="Visiteur"
                    maxLength={50}
                    placeholder={t(translations.APPOINTMENT_MODAL_LAST_NAME_LABEL)}
                    value={showVLastName}
                    onChange={(e) => setVLastName(e.currentTarget.value)}
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    {t(translations.APPOINTMENT_MODAL_LAST_NAME_ERROR)}
                  </Form.Control.Feedback>
                </Col>
              </Form.Group>
              <Form.Group as={Row} controlId="formHorizontalVisiteurF">
                <Form.Label column sm={4}>
                  {t(translations.APPOINTMENT_MODAL_FIRST_NAME) + ':'}
                </Form.Label>
                <Col sm={8}>
                  <Form.Control
                    type="Visiteur"
                    maxLength={50}
                    placeholder={t(translations.APPOINTMENT_MODAL_FIRST_NAME_LABEL)}
                    value={showVFirstName}
                    onChange={(e) => setVFirstName(e.currentTarget.value)}
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    {t(translations.APPOINTMENT_MODAL_FIRST_NAME_ERROR)}
                  </Form.Control.Feedback>
                </Col>
              </Form.Group>
              {showVisitorEmailRequired == true ?
              <>
                <Form.Group as={Row} controlId="formHorizontalVisiteurF">
                  <Form.Label column sm={4}>
                    {t(translations.VISITOR_EMAIL) + ':'}
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      required={showVisitorEmailRequired}
                      maxLength={100}
                      type="email"
                      placeholder={t(translations.VISITOR_EMAIL_LABEL)}
                      value={showVisitorEmail}
                      onChange={(e) => setVisitorEmail(e.currentTarget.value)}
                      disabled={noEmailChecked}
                    />
                    <Form.Control.Feedback type="invalid">
                      {t(translations.EMAIL_ERROR)}
                    </Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="formHorizontalVisiteurF">
                  <Col sm={8}>
                    <div>
                      <input type="checkbox" id="coding" name="interest" value="coding" checked={noEmailChecked} onChange={(e) => {
                        setNoEmailChecked(e.target.checked);
                        if (e.target.checked) {
                          handleIconClick();
                          setVisitorEmail('email@email.com'); // Set default value
                        } else {
                          setVisitorEmail(''); // Clear the email field if unchecked
                        }
                      }} />
                      <label htmlFor="coding" style={{marginLeft: 8}}>{t(translations.NO_EMAIL)}</label>
                    </div>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="formHorizontalLanguageMail">
                  <Form.Label column sm={4}>{t(translations.LANGUAGE_MAIL)}</Form.Label>
                  <Col sm={8} style={{zIndex: 100}}>
                    <Select
                      isClearable={false}
                      isSearchable={false}
                      components={animatedComponents}
                      value={showLanguageMail}
                      options={[{'value': 'fr', 'label': t(translations.LANGUAGE_MAIL_FR)}, {'value': 'en', 'label': t(translations.LANGUAGE_MAIL_EN)}]}
                      onChange={(e) => setLanguageMail(e)}
                    />
                  </Col>
                </Form.Group>
              </>: null
              }
              <Form.Group as={Row} controlId="formHorizontalVisiteurF">
                <Form.Label column sm={4}>
                  {t(translations.VISITOR_ENTREPRISE) + ':'}
                </Form.Label>
                <Col sm={8}>
                  <Form.Control
                    maxLength={100}
                    type="name"
                    placeholder={t(translations.VISITOR_ENTREPRISE_LABEL)}
                    value={showVisitorEntreprise}
                    onChange={(e) => setVisitorEntreprise(e.currentTarget.value)}
                  />
                  <Form.Control.Feedback type="invalid">
                    {t(translations.EMAIL_ERROR)}
                  </Form.Control.Feedback>
                </Col>
              </Form.Group>
              <Form.Group as={Row} controlId="formHorizontalHour">
                <Form.Label column sm={4}>
                  {t(translations.TIME) + ':'}
                </Form.Label>
                <Col sm={8}>
                  <TimePickerComponent required showHour={checkTime()} setHour={setHour} validated={validated} />
                </Col>
              </Form.Group>
              <Form.Group as={Row} controlId="formHorizontalDate">
                <Form.Label column sm={4}>
                  {t(translations.DATE) + ':'}
                </Form.Label>
                <Col sm={8}>
                  <DatePickerComponent required showDate={showDate} setDate={setDate} min={showTodayDate} max={showMaxdayDate} validated={validated} />
                </Col>
              </Form.Group>
              <Form.Group as={Row} controlId="formHorizontalComments">
                <Form.Label column sm={4}>
                  {t(translations.COMMENTARY) + ':'}
                </Form.Label>
                <Col sm={8}>
                  <Form.Control
                    as="textarea"
                    type="Commentaire"
                    maxLength={200}
                    placeholder={t(translations.COMMENTARY)}
                    value={showComments}
                    onChange={(e) => setComments(e.currentTarget.value)}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Button
                  className="btn-simple btn-round col-sm-6"
                  type="button"
                  variant="link"
                  onClick={() => setShowModal(false)}
                >
                  {t(translations.CLOSE)}
                </Button>
                <Button className="btn-round col-sm-6" type="submit">
                  {t(translations.EDIT)}{' '}
                </Button>{' '}
              </Form.Group>
            </Form>
          </div>:
          <div className="modal-body" style={{alignItems: 'center', justifyContent: 'center', width: '100%', display: 'flex'}}>
            <CircularProgress style={{color: '#F6B540'}}/>
          </div>
        }
      </Modal>
    </>
  );
};

export default ModalEDITTableList;
